import { ActionCreatorProps, createAction, props } from '@ngrx/store';
import {
    DatiqAnalyticsInputInteraction,
    DATIQ_INPUT_BUTTON,
    IDatiqAnalyticsEvent,
} from '@dat/datiq-core/models';

export const PREFIX = `[Datiq ${DATIQ_INPUT_BUTTON}]`;

const createActionName: (name: string) => string = (name: string) => {
    return `${PREFIX} ${name}`;
};

const defaultProp: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const clickName = createActionName(
    `${DatiqAnalyticsInputInteraction.Click}`
);
export const noActionFiredName = createActionName(
    `${DatiqAnalyticsInputInteraction.Click}`
);
export const noAction = createAction(noActionFiredName);

export const click = createAction(clickName, defaultProp);
